export function setWithExpiry(key, value, ttl = 3600000, originalKey = false) {
    const now = new Date();

    if (ttl == 0) {
        ttl = 3600000;
    }
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    };
    if (!originalKey) {
        key = this.getCacheKey(key);
    }
    try {
        localStorage.removeItem(key);
        localStorage.setItem(key, JSON.stringify(item));
    } catch (e) { }
}
export function getCacheKey(key) {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user && user.active_role) {
        let pathname = window.location.pathname
            .split("/")
            .map(function (item) {
                if (!isNaN(parseInt(item))) {
                    return "*";
                }
                return item;
            })
            .join("/");
        key = user.active_role.name + pathname + "_" + key;
    }
    return key;
}
export function getWithExpiry(key, originalKey = false) {
    if (!originalKey) {
        key = this.getCacheKey(key);
    }
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}
